type MenuItemLike = {
  display?: boolean;
  children?: MenuItemLike[];
  onClick?: () => void;
};

/**
 * 从菜单列表中找第一个可展示的菜单项（有 onClick 的叶子或自身可点击的项）
 */
export function findFirstAvailableMenuItem(menuItems: MenuItemLike[]): { onClick: () => void } | null {
  for (const item of menuItems) {
    if (item.display === false) continue;
    if (item.children?.length) {
      const first = item.children.find((c: MenuItemLike) => c.display !== false);
      if (first?.onClick) return { onClick: first.onClick };
    }
    if (item.onClick) return { onClick: item.onClick };
  }
  return null;
}
